import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { LANGUAGES } from "@/i18n/translations";

const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-switcher"
      className={`flex items-center gap-2 text-[13px] font-medium ${className}`}
    >
      {LANGUAGES.map((l, idx) => (
        <React.Fragment key={l.code}>
          <button
            type="button"
            data-testid={`lang-${l.code}`}
            data-active={lang === l.code}
            onClick={() => setLang(l.code)}
            className="lang-pill px-1 py-0.5"
            aria-label={`Switch language to ${l.label}`}
          >
            {l.label}
          </button>
          {idx < LANGUAGES.length - 1 && (
            <span className="text-white/30">|</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
